import { render, staticRenderFns } from "./moreinfo.vue?vue&type=template&id=6a5bccb1&scoped=true&"
import script from "./moreinfo.vue?vue&type=script&lang=js&"
export * from "./moreinfo.vue?vue&type=script&lang=js&"
import style0 from "./moreinfo.vue?vue&type=style&index=0&id=6a5bccb1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5bccb1",
  null
  
)

export default component.exports